import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';

export type WipeType = 'up' | 'down' | 'left' | 'right';

const rightToLeftWipe = keyframes`
0% {
  clip-path: inset(0 100% 0 0);
}
100% {
  clip-path: inset(0)
}`;

const leftToRightWipe = keyframes`
0% {
  clip-path: inset(0 0 0 100%);
}
100% {
  clip-path: inset(0)
}`;

const topDownWipe = keyframes`
0% {
  clip-path: inset(0 0 100% 0);
}
100% {
  clip-path: inset(0)
}
`;

const upWipe = keyframes`
0% {
  clip-path: inset(100% 0 0% 0);
}
100% {
  clip-path: inset(0)
}
`;

const getAnimation = (wipeDirection: WipeType) => {
  if (wipeDirection === 'down') {
    return topDownWipe;
  }
  if (wipeDirection === 'right') {
    return rightToLeftWipe;
  }
  if (wipeDirection === 'left') {
    return leftToRightWipe;
  }
  if (wipeDirection === 'up') {
    return upWipe;
  }

  return rightToLeftWipe;
};

export const WipeAnimation = styled.div<{
  speed: number;
  isStandard: boolean;
  isNav?: boolean;
  isAbsoluteImage?: boolean;
  wipeDirection: WipeType;
  delay: number;
  easeFunction: string;
}>`
  ${(props) =>
    props.isStandard === true &&
    css`
      animation: ${getAnimation(props.wipeDirection)} ${props.speed}s ${props.delay}s
        ${props.easeFunction};
    `};
  ${(props) =>
    props.isAbsoluteImage === true &&
    css`
      > img {
        animation: ${getAnimation(props.wipeDirection)} ${props.speed}s ${props.delay}s
          ${props.easeFunction};
      }
    `};

  ${(props) =>
    props.isNav === true &&
    css`
      ul > * {
        animation: ${getAnimation(props.wipeDirection)} ${props.speed}s ${props.easeFunction};
      }
    `};
`;
